const TABS = {
  STUDENT: 'STUDENT',
  EXERCISE: 'EXERCISE',
} as const;

export type Tab = typeof TABS[keyof typeof TABS];

export default TABS;
